import MainNavbar from "../components/reuse/navbar";

export default function StatisticReportsPage(){
    return(
         <>
            <div>
                <MainNavbar/>
            </div>
            <div className="block">
                <h1>Страница со статистическим отчётом</h1>
            </div>
        </>
    )
}